import { render } from "./notification_filters.vue?vue&type=template&id=afbf2f10"
import script from "./notification_filters.vue?vue&type=script&lang=js"
export * from "./notification_filters.vue?vue&type=script&lang=js"

import "./notification_filters.vue?vue&type=style&index=0&id=afbf2f10&lang=scss"

import exportComponent from "M:\\Viridian Patriots\\Server\\pleroma-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__